import { createRoot } from 'react-dom/client'
import { App } from './App'
import './assets/index.css'
import { enableKeyboardFocusFixes } from './utils/keyboardFocus'

const container = document.getElementById('root')
const root = createRoot(container!)
window.global = window

root.render(<App />)
enableKeyboardFocusFixes()
